import { Deferred, format, Instance, Objekt } from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from './assetService';
import { GoogleAnalytics4Service } from './googleAnalytics4Service';
import { LanguageService } from './languageService';
import { ModelService } from './modelService';

export class OrderService extends ModelService {
    static readonly inject = [
        'instances',
        'languageService',
        'assetService',
        'googleAnalytics4Service',
    ];

    googleAnalytics4Service: GoogleAnalytics4Service;

    constructor(
        instances: Instance,
        $languageService: LanguageService,
        $assetService: AssetService,
        googleAnalytics4Service: GoogleAnalytics4Service,
    ) {
        super(
            'order-orders-order_id',
            instances,
            $languageService,
            $assetService,
        );

        this.googleAnalytics4Service = googleAnalytics4Service;
    }

    createByOrganization(organizationId: string, order: Objekt) {
        const deferred = new Deferred<Objekt, Objekt>();
        this.http
            .post(
                format('/api/v1/organizations/{0}/orders.json', [
                    organizationId,
                ]),
                order,
            )
            .then(
                (response) => {
                    this.googleAnalytics4Service.purchaseItem(
                        response.get<string>('order.order_id'),
                        response.get<string>('order.license_type') +
                            '_' +
                            response.get<number>('order.year_id'),
                        response.get<string>('order.license_type'),
                        response.get<string>('organization.name'),
                        response.get<string>('order.price'),
                        response.get<string>('order.currency'),
                    );
                    deferred.resolve(response);
                },
                (response) => {
                    deferred.reject(response);
                },
            );
        return deferred.promise();
    }

    execute(paymentParams: Objekt) {
        return this.http.post(
            format('/api/v1/orders/execute.json'),
            paymentParams,
        );
    }

    reject(paymentParams: Objekt) {
        return this.http.post(
            format('/api/v1/orders/reject.json'),
            paymentParams,
        );
    }
}

export const orderService = app.service('orderService', OrderService);
